import { useState } from "react";

import {
	BriefCase,
	Key,
	PaymentCard,
	People,
	Rocket,
	SearchIcon,
	Settings,
} from "../../assets/icons/interface/interface";
import CandidateSupportModal from "../../components/CandidateSupportModal/CandidateSupportModal";
import AskedQuestion from "../../components/FAQ/AskedQuestion";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import useIsLoggedIn from "../../hooks/use-IsLoggedIn";
import Faqs from "../../seed/Faqs";
import Header from "../Profile/components/Header";
import Footer from "../StaticPages/Footer";

function NeedHelp() {
	const isLoggedIn = useIsLoggedIn();
	const [searchTerm, setSearchTerm] = useState("");
	const [showSupportRequestDialog, setShowSupportRequestDialog] = useState(false);

	const handleCloseSupportRequestDialog = () => {
		setShowSupportRequestDialog(false);
	};

	return (
		<div>
			{showSupportRequestDialog && (
				<CandidateSupportModal
					show={showSupportRequestDialog}
					close={handleCloseSupportRequestDialog}
					useTailwind={true}
				/>
			)}
			<Header isLoggedIn={isLoggedIn} />
			<div className="bg-[#1E40AF] min-h-[342px] flex flex-col items-center justify-center px-8 pb-4 md:pb-0">
				<div className="text-[42px] text-white font-bold text-center">Need Help? We’ve Got You</div>
				<Button
					className="rounded-[9999px] w-[185px] h-14"
					onClick={() => {
						setShowSupportRequestDialog(true);
					}}
				>
					Request Support
				</Button>
				<div className="text-2xl text-white font-normal py-6 text-center">
					Find answers, get support, or talk to us—whatever you need, we’re here.
				</div>
				<div className="flex items-center justify-center gap-3 md:gap-12 w-full">
					<div className="w-full max-w-[675px] relative border border-white rounded">
						<div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none">
							<SearchIcon className="h-4 w-4 text-white" />
						</div>
						<Input
							type="text"
							placeholder="Search for help..."
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							className="h-12 bg-transparent border-0 ring-0 focus:ring-0 pl-10 placeholder:text-white text-white"
						/>
					</div>
					<Button className="bg-white text-primary-800 h-9 hover:bg-white">Search</Button>
				</div>
			</div>
			<div className="py-16">
				<div className="container max-w-[1243px]">
					<div className="grid grid-cols-1 md:grid-cols-3 gap-6">
						{[
							{
								icon: <Rocket />,
								title: "Getting Started",
								description: "Set up your account, explore key features,",
							},
							{
								icon: <Key />,
								title: "Account & Login",
								description: "Reset your password, update email, manage security settings.",
							},
							{
								icon: <PaymentCard />,
								title: "Billing & Usage",
								description: "View invoices, download receipts, resolve payment issues",
							},
							{
								icon: <BriefCase />,
								title: "Job Listings & Applications",
								description: "Post, edit, or manage job listings, add applicants.",
							},
							{
								icon: <Settings />,
								title: "Technical Support",
								description: "Troubleshoot errors, report bugs, and fix common issues.",
							},
							{
								icon: <People />,
								title: "Team & Permissions",
								description: "Add or remove team members, manage access levels, add another team.",
							},
						].map((item, index) => {
							return (
								<div key={index} className="p-8 border border-[#EDEEF1] rounded-[10px]">
									<div className="space-y-2.5">
										{item.icon}
										<div className="text-xl font-semibold">{item.title}</div>
										<div className="text-lg font-medium text-anima-gray-text-2">{item.description}</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<div className="container max-w-[1243px] py-16">
				<div className="text-center text-[34px] font-bold text-[#007BFF] pb-8">Frequently Asked Questions</div>
				{Faqs().map((item, index) => {
					return <AskedQuestion key={index} item={item} />;
				})}
			</div>
			<div className="bg-white pt-24 pb-16">
				<div className="container max-w-[915px] text-center space-y-4">
					<h2 className="text-[36px] font-bold">Still have questions? Let us know!</h2>
					<p className="text-xl font-normal pb-4">
						If you couldn’t find an answer, we’d love to help. Share your question, issue, or request, and we’ll take it
						from there!
					</p>
					<Button
						className="rounded-[9999px] w-[185px] h-14"
						onClick={() => {
							setShowSupportRequestDialog(true);
						}}
					>
						Request Support
					</Button>
				</div>
			</div>
			<Footer variant="employer" />
		</div>
	);
}

export default NeedHelp;
